import React, { memo, useMemo, useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { singleValue, orderStatus, getIndicators } from "../../../utils";
import { validPogItem } from "../../../utils/itemValidator";
import InlineItemLoader from "./InlineItemLoader";

const CustomItemContainerSx = {
  display: "flex",
};

const CustomItemExpandableContainerSx = {
  ...CustomItemContainerSx,
  marginBottom: "0px",
};

const LoadingItemContainerSx = {
  display: "flex",
  minHeight: "38px",
  alignItems: "center",
  paddingLeft: "5px",
  fontSize: "12px",
};

const ItemPaperSx = (
  virtualLoading = true,
  itemBlocked = false,
  itemDiscontinued = false,
  itemRestricted = false,
  itemSelected = false,
  itemReleased = false,
  itemExisting = false,
  itemFillIn = false
) => ({
  marginBottom: "1px",
  backgroundColor: itemBlocked ? "#00000014" : "",
  overflow: "none",
  boxShadow: !virtualLoading
    ? getIndicators(
        itemDiscontinued,
        itemRestricted,
        itemSelected,
        itemReleased,
        itemExisting,
        false,
        itemFillIn
      )
    : "",
});

function CustomItem({ item, onChange, collapsedView, expandedView }) {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (item?.virtualLoading) {
      setExpanded(false);
    }
  }, [item?.virtualLoading]);

  useEffect(() => {
    onChange && onChange();
  }, [expanded, onChange]);

  const handleExpand = (e) => {
    setExpanded(!expanded);
  };

  const virtualLoading = item?.virtualLoading;

  const isSelected = useMemo(
    () => item?.SelectedItem === singleValue.yes,
    [item?.SelectedItem]
  );
  const isRestricted = useMemo(
    () => item?.Restricted === singleValue.yes,
    [item?.Restricted]
  );
  const isDiscontinued = useMemo(() => Boolean(item?.DiscInd), [item?.DiscInd]);
  const isReleased = useMemo(
    () => item?.ReleaseStatus === orderStatus.released,
    [item?.ReleaseStatus]
  );
  const isExisting = useMemo(
    () => item?.SelectedItem === singleValue.existing,
    [item?.SelectedItem]
  );
  const isFillIn = useMemo(
    () => Boolean(item?.IsFromFillIn),
    [item?.IsFromFillIn]
  );
  const itemBlocked = useMemo(() => !validPogItem(item), [item]);

  return (
    <Paper
      sx={ItemPaperSx(
        virtualLoading,
        itemBlocked,
        isDiscontinued,
        isRestricted,
        isSelected,
        isReleased,
        isExisting,
        isFillIn
      )}
    >
      {virtualLoading ? (
        <div style={LoadingItemContainerSx}>
          <InlineItemLoader />
        </div>
      ) : (
        <>
          <div style={CustomItemContainerSx}>
            {collapsedView}
            <IconButton
              size="small"
              aria-label="expand"
              component="label"
              sx={{ display: "inline-flex" }}
              onClick={handleExpand}
            >
              {!expanded ? (
                <KeyboardArrowRightIcon fontSize="inherit" />
              ) : (
                <KeyboardArrowDownIcon fontSize="inherit" />
              )}
            </IconButton>
          </div>
          <div style={CustomItemExpandableContainerSx}>
            {expanded && <>{expandedView}</>}
          </div>
        </>
      )}
    </Paper>
  );
}

export default memo(CustomItem);
